import { render, staticRenderFns } from "./PedidoDeCompraRevisaoDePedidoDeCompraView.vue?vue&type=template&id=18e4d0c3&scoped=true"
import script from "./PedidoDeCompraRevisaoDePedidoDeCompraView.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoDeCompraRevisaoDePedidoDeCompraView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PedidoDeCompraRevisaoDePedidoDeCompraView.vue?vue&type=style&index=0&id=18e4d0c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e4d0c3",
  null
  
)

export default component.exports